"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var userClientDetailsController = function userClientDetailsController() {
  "ngInject";

  (0, _classCallCheck3.default)(this, userClientDetailsController);
};

exports.default = userClientDetailsController;


/** WEBPACK FOOTER **
 ** ./client/app/common/Components/user-client-details/user-client-details.controller.js
 **/